/**
 * humanize — render a machine identifier as a human label (PRD §38.1).
 *
 * snake_case / dotted machine ids become sentence-case prose, e.g.
 *   humanize('counterfeit_signal') -> 'Counterfeit signal'
 *   humanize('verified_machine')   -> 'Verified machine'
 *   humanize('e2_ubo')             -> 'E2 ubo'
 *
 * Pure: same input always yields the same output. Faithful to the prototype's
 * helper (replace separators with spaces, upper-case the first letter).
 */
export function humanize(value) {
    return String(value)
        .replace(/[._]+/g, ' ')
        .trim()
        .replace(/^\w/, (c) => c.toUpperCase());
}
//# sourceMappingURL=humanize.js.map